import React, { FC } from 'react';

export const Shape: FC = () => (
  <svg width="50" height="30" viewBox="0 0 50 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.1081 16.9076C49.2076 17.7184 48.981 18.5355 48.4781 19.1793L44.6855 24.0335C44.1826 24.6772 43.4445 25.0948 42.6337 25.1944L38.8059 25.6644L38.8059 25.6646L13.3299 28.7926L13.3299 28.7923L4.15777 29.9185C3.03217 30.0567 2.00765 29.2563 1.86944 28.1307L0.0229699 13.0924C-0.0765836 12.2816 0.150029 11.4644 0.652955 10.8207L4.44552 5.96644C4.94845 5.32273 5.68649 4.90516 6.49729 4.80561L12.3643 4.08524L12.3643 4.08553L33.7639 1.458L33.7638 1.45778L44.9733 0.0814343C46.0989 -0.0567721 47.1234 0.743667 47.2616 1.86927L49.1081 16.9076Z"
      fill="#DD2926"
    />
  </svg>
);
